import type { IconProps } from './IconProps';

export const CheckmarkIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5303 4.46967C13.8232 4.76256 13.8232 5.23744 13.5303 5.53033L6.53033 12.5303C6.23744 12.8232 5.76256 12.8232 5.46967 12.5303L2.46967 9.53033C2.17678 9.23744 2.17678 8.76256 2.46967 8.46967C2.76256 8.17678 3.23744 8.17678 3.53033 8.46967L6 10.9393L12.4697 4.46967C12.7626 4.17678 13.2374 4.17678 13.5303 4.46967Z"
      fill="currentColor"
    />
  </svg>
);
